// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-ImagePreview-ImagePreview-module__box--GjBIZ {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
}
.src-components-ImagePreview-ImagePreview-module__imageBox--fztWP {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
}
.src-components-ImagePreview-ImagePreview-module__imageBox--fztWP img {
  width: 100%;
  height: auto;
}
.src-components-ImagePreview-ImagePreview-module__counter--ncLM5 {
  text-align: center;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
}
/*# sourceMappingURL=ImagePreview.module.css.map */`, "",{"version":3,"sources":["webpack://./ImagePreview.module.less","webpack://./src/components/ImagePreview/ImagePreview.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EAEA,gBAAA;EACA,YAAA;EACA,eAAA;ACAF;ADGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;ACDF;ADJA;EAOI,WAAA;EACA,YAAA;ACAJ;ADIA;EACE,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACFF;AACA,kDAAkD","sourcesContent":[".box {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.imageBox {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 48px;\n  height: 48px;\n  img {\n    width: 100%;\n    height: auto;\n  }\n}\n\n.counter {\n  text-align: center;\n  overflow: hidden;\n  color: rgba(0, 0, 0, 0.85);\n  text-overflow: ellipsis;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n}\n",".box {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n.imageBox {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 48px;\n  height: 48px;\n}\n.imageBox img {\n  width: 100%;\n  height: auto;\n}\n.counter {\n  text-align: center;\n  overflow: hidden;\n  color: rgba(0, 0, 0, 0.85);\n  text-overflow: ellipsis;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n}\n/*# sourceMappingURL=ImagePreview.module.css.map */"],"sourceRoot":""}]);
// Exports
export var box = `src-components-ImagePreview-ImagePreview-module__box--GjBIZ`;
export var imageBox = `src-components-ImagePreview-ImagePreview-module__imageBox--fztWP`;
export var counter = `src-components-ImagePreview-ImagePreview-module__counter--ncLM5`;
export default ___CSS_LOADER_EXPORT___;
